/* eslint-disable complexity */
import React from 'react';
import LandingAppPriceMarker from './LandingApp/PriceMarker';

import {getMarkerUuid} from '../../utils/markers';
import {APP_NAMES, MARKER_TYPES} from '../../constants';

import './Marker.less';
import BaseMarker from './BaseMarker';
import PointOfInterestMarker from './LandingApp/PointOfInterestMarker';
import DestinationMarker from './LandingApp/DestinationMarker';
import PriceMarker from './Tripboards/PriceMarker';
import {useMapContext} from '../../context/MapContext';
import ThingsOfInterestMarker from './ThingsOfInterestMarker';

const Marker = (props) => {
    const mapContext = useMapContext();
    const {marker, type, onClick, onHover, onHoverLeave, index, map} = props;

    const uuid = getMarkerUuid(marker);

    switch (mapContext.appName) {
        case APP_NAMES.LANDINGAPP:
            switch (marker.type) {
                case MARKER_TYPES.PRICE:
                    return (
                        <LandingAppPriceMarker
                            {...marker}
                            map={map}
                            id={uuid}
                            key={uuid}
                        />
                    );
                case MARKER_TYPES.POI:
                    return (
                        <PointOfInterestMarker
                            {...marker}
                            map={map}
                            id={uuid}
                            key={uuid}
                            onClick={() => {
                                onClick(uuid);
                            }}
                            onHover={() => {
                                onHover(uuid);
                            }}
                            onHoverLeave={onHoverLeave}
                        />
                    );
                case MARKER_TYPES.DESTINATION:
                    return (
                        <DestinationMarker
                            {...marker}
                            map={map}
                            id={uuid}
                            key={uuid}
                            onClick={() => {
                                onClick(uuid);
                            }}
                        />
                    );
                default:
                    return null;
            }
        case APP_NAMES.TRIPBOARDS:
            switch (marker.type) {
                case MARKER_TYPES.PRICE:
                    return (
                        <PriceMarker
                            map={map}
                            {...marker}
                            id={uuid}
                            key={uuid}
                            onClick={() => {
                                onClick(uuid);
                            }}
                            onHover={() => {
                                onHover(uuid);
                            }}
                            onHoverLeave={onHoverLeave}
                        />
                    );
                default:
                    return null;
            }
        default:
            switch (type) {
                case MARKER_TYPES.TOI:
                    return (
                        <ThingsOfInterestMarker
                            map={map}
                            index={index}
                            id={uuid}
                            key={uuid}
                            onClick={() => {
                                onClick(uuid);
                            }}
                            onHover={() => {
                                onHover(uuid);
                            }}
                            onHoverLeave={onHoverLeave}
                            {...marker}
                        />
                    );

                default:
                    return (
                        <BaseMarker
                            {...marker}
                            map={map}
                            index={index}
                            id={uuid}
                            key={uuid}
                            onClick={() => {
                                onClick(uuid);
                            }}
                            onHover={() => {
                                onHover(uuid);
                            }}
                            onHoverLeave={onHoverLeave}
                        />
                    );
            }
    }
};

export default Marker;
